import React, { Component } from 'react';
import Utils from 'libs/Utils';
import PropTypes from 'prop-types';

import Header from 'components/Header';
import OrderInformation from 'components/OrderInformation';
import Button from 'components/Button';

import './styles.css';
import confirm from './img/confirm.svg';
import plus from './img/plus.svg';
import eye from './img/eye.svg';
import coinhodler from './img/coinhodler.svg';
import coinranking from './img/coinranking.svg';

class Success extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    let fromIcon;
    switch (this.props.exchangeStore.exchange.fromCoin.iconType) {
      case 'vector':
        fromIcon = (
          <img
            className="transaction__img"
            src={this.props.exchangeStore.exchange.fromCoin.iconUrl}
            alt={`${this.props.exchangeStore.exchange.fromCoin.name} (${this.props.exchangeStore.exchange.fromCoin.symbol}) icon`}
            width="40"
            height="40"
          />
        );
        break;
      case 'pixel':
        fromIcon = (
          <img
            className="transaction__img"
            src={`${this.props.exchangeStore.exchange.fromCoin.iconUrl}?size=80`}
            alt={`${this.props.exchangeStore.exchange.fromCoin.name} (${this.props.exchangeStore.exchange.fromCoin.symbol}) icon`}
            width="40"
            height="40"
          />
        );
        break;
      default:
        fromIcon = (
          <span className="transaction__img transaction__img--placeholder" />
        );
    }

    let toIcon;
    switch (this.props.exchangeStore.exchange.toCoin.iconType) {
      case 'vector':
        toIcon = (
          <img
            className="transaction__img"
            src={this.props.exchangeStore.exchange.toCoin.iconUrl}
            alt={`${this.props.exchangeStore.exchange.toCoin.name} (${this.props.exchangeStore.exchange.toCoin.symbol}) icon`}
            width="40"
            height="40"
          />
        );
        break;
      case 'pixel':
        toIcon = (
          <img
            className="transaction__img"
            src={`${this.props.exchangeStore.exchange.toCoin.iconUrl}?size=80`}
            alt={`${this.props.exchangeStore.exchange.toCoin.name} (${this.props.exchangeStore.exchange.toCoin.symbol}) icon`}
            width="40"
            height="40"
          />
        );
        break;
      default:
        toIcon = (
          <span className="transaction__img transaction__img--placeholder" />
        );
    }

    console.log(this.props.exchangeStore.exchange.fromAmount);

    return (
      <div className="success">
        <Header step={4} light />
        <div className="content">
          <div className="status">
            <img className="status__img" src={confirm} width="34" height="26" alt="Success" />
          </div>

          <h1 className="title">Your exchange was successful!</h1>

          <div className="buttons">
            {this.props.exchangeStore.exchange.toTransaction &&
            this.props.exchangeStore.exchange.toTransaction.url ?
              <Button
                type="link"
                target="_blank"
                imgLeft={eye}
                color="green"
                text="View transaction"
                href={this.props.exchangeStore.exchange.toTransaction.url}
              />
            : null}
          </div>

          <ul className="transactions">
            <li className="transaction">
              <div className="transaction__label">You sent</div>
              <div className="transaction__block">
                <div className="transaction__details">
                  {fromIcon}
                </div>
                <div className="transaction__amount">{Utils.numberFormat(this.props.exchangeStore.exchange.fromAmount, '?')}</div>
              </div>
            </li>
            <li className="transaction">
              <div className="transaction__label">You received</div>
              <div className="transaction__block">
                <div className="transaction__details">
                  {toIcon}
                </div>
                <div className="transaction__amount">{Utils.numberFormat(this.props.exchangeStore.exchange.toAmount, '?')}</div>
              </div>
            </li>
          </ul>

          <OrderInformation exchangeStore={this.props.exchangeStore} />
        </div>

        <div className="partners">
          <a className="partner partner--coinhodler" href="https://coinhodler.io">
            <img className="partner__logo" src={coinhodler} width="19" height="19" alt="Coinhodler" />
            Edit your portfolio
          </a>
          <a className="partner partner--coinranking" href="https://coinranking.com">
            <img className="partner__logo" src={coinranking} width="19" height="19" alt="Coinranking" />
            Go to Coinranking
          </a>
          <Button
            className="partners__button"
            imgLeft={plus}
            color="light-blue"
            text="New exchange"
            href="/"
          />
        </div>
      </div>
    );
  }
}

Success.propTypes = {
  exchangeStore: PropTypes.object.isRequired,
};

export default Success;



// WEBPACK FOOTER //
// ./src/scenes/Exchange/scenes/Success/index.jsx